import { useFormikContext } from 'formik';

import { useSettingsSaveBar } from './useSettingsSaveBar';

/** The subset of FormPage's header props the save bar needs. */
interface SettingsFormSaveBarProps {
  onCancel: (() => void) | undefined;
  isSubmitting?: boolean;
  dirty?: boolean;
  /** FormPage also sets this on unchanged forms that allow saving, e.g. to turn a disabled module on. */
  showActions?: boolean;
  /** FormPage's `disableSubmit` / submit tooltip, which the old header honoured too. */
  isDisabled?: boolean;
}

/**
 * A FormPage `HeaderComponent` that hands the form to the settings save bar
 * instead of rendering its own buttons. A page moving onto the new layout
 * passes `HeaderComponent={SettingsFormSaveBar}` to its SettingsPageForm.
 */
export const SettingsFormSaveBar = ({
  onCancel,
  isSubmitting = false,
  dirty = false,
  showActions = false,
  isDisabled = false,
}: SettingsFormSaveBarProps) => {
  const { submitForm } = useFormikContext();

  useSettingsSaveBar({
    dirty: dirty || showActions,
    saving: isSubmitting,
    saveDisabled: isDisabled,
    onSave: () => void submitForm(),
    onCancel: () => onCancel?.(),
  });

  return null;
};
